"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagName = exports.Tag = exports.StyledIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//components

//constants
var gutter = 8;
var Tag = exports.Tag = _styledComponents["default"].div.withConfig({
  displayName: "styles__Tag",
  componentId: "sc-1do7hdr-0"
})(["height:24px;align-items:center;background:#ececec;border-radius:2px;color:#333330;display:inline-flex;font-size:14px;line-height:18px;padding:0 12px;cursor:default;", ""], function (p) {
  return p.onClick && "\n    cursor: pointer;\n    transition: 0.2s background ease-out;\n\n    &:hover {\n      transition: none;\n    }\n  ";
});
var TagName = exports.TagName = _styledComponents["default"].div.withConfig({
  displayName: "styles__TagName",
  componentId: "sc-1do7hdr-1"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-1do7hdr-2"
})(["color:", ";margin-left:5px;"], function (p) {
  return p.theme.buttonColor;
});
//# sourceMappingURL=styles.js.map